import receipt from "../../assets/img/receipt.jpg";
import { formatNumber } from "../data/essential";
import moment from "moment";
import { editPayment, viewPaymentReceipt } from "../../utils/roles"
const paymentColumns = (roles, storeEntireRow, showPaymentReceipt) => {
  const columns = [
    { name: "Id", cell: (row) => row["id"] },
    { name: "Account Id", cell: (row) => row["accountId"] },
    {
      name: "Datetime",
      cell: (row) => moment(row["datetime"]).format("DD-MM-YYYY hh:mm:ss A"),
    },
    {
      name: (
        <div className='sc-dQoVA huizgM'>
          Collection
          <br /> Account
        </div>
      ),
      cell: (row) => row["collectionAccount"]["name"],
    },
    { name: "TID", cell: (row) => row["transactionId"] },
    { name: "Payer", cell: (row) => row["payer"]["paymentNumber"] },
    { name: "Amount", cell: (row) => `${formatNumber(row["amount"])} RWF` },
    { name: "Status", cell: (row) => row["status"]["name"] },
    { name: "Info", cell: (row) => row["paymentInfo"] },
    {
      name: roles?.some((role) => role.id === editPayment)
        ? "Receipt"
        : "",
      cell: (row) => (
        <>
          {row["status"]["name"] === "SUCCESSFUL" &&
            roles?.some((role) => role.id === viewPaymentReceipt) && (
              <img
                src={receipt}
                width={30}
                height={20}
                className='ml-4'
                onClick={() => {
                  showPaymentReceipt(true);
                  storeEntireRow(row);
                }}
                style={{ cursor: "pointer" }}
              />
            )}
        </>
      ),
    },
  ];
  return columns;
};
export default paymentColumns;
